// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper___u40A","itemTitle":"ClientEmergencyInfo_itemTitle__T95AG","itemText":"ClientEmergencyInfo_itemText__1_5E4"};